export default __webpack_public_path__ + "static/Montserrat-ExtraBold-1944c8d1a118759a443517c1337aafdc.ttf";